// Horse.jsx
import { useState, useEffect } from "react";
import "../../assets/styles/Cricket.css";
import Menu_select from "../../components/Menu_select";
import Bet_slip from "../../components/Bet_slip";
import MatchSchulte from "../../components/MatchSchulte/MatchSchulte";
import { horseRace } from "../../../../AsianExchangeSrc/api";
import { subscribeToHorseMatchesData } from "../../../../socketClient";
import { useSelector } from "react-redux";

const Horse = () => {
  const [loading, setLoading] = useState(false);
  // const [data, setData] = useState(null);
  const data = useSelector((state) => state?.horse?.horseRaceList);

  // const fetchData = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await horseRace();
  //     setData(response?.data?.data?.t1);
  //   } catch (error) {
  //     console.error("Error fetching horse race data:", error);
  //     setData(null);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    // fetchData();
    // const intervalId = setInterval(fetchData, 60000);
    // return () => clearInterval(intervalId);
    subscribeToHorseMatchesData();
  }, []);

  return (
    <div className="Cricket-wrap">
      <Menu_select />
      <MatchSchulte
        cricketMatches={data}
        MatchName="Horse Racing Schedule"
        loader={loading}
      />
      <Bet_slip />
    </div>
  );
};

export default Horse;
